import { render, staticRenderFns } from "./TenantSettingsLicenseCounts.vue?vue&type=template&id=25a34648"
import script from "./TenantSettingsLicenseCounts.vue?vue&type=script&lang=js"
export * from "./TenantSettingsLicenseCounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports